import classes from './PromotionalBanner.module.scss';
import ChatBanner from '../chatBanner/ChatBanner';

export default function PromotionalBanner(props) {
    return (
        <div className={classes.oPromotionalBanner}>
            <div className={`${classes.oContainer} container`}>
                <ChatBanner {...props} />
            </div>
        </div>
    );
}
